import { render, staticRenderFns } from "./EditBuyer.vue?vue&type=template&id=05c7d74e&scoped=true&"
import script from "./EditBuyer.vue?vue&type=script&lang=js&"
export * from "./EditBuyer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c7d74e",
  null
  
)

export default component.exports